// Configuration Firebase simplifiée pour OPTIC LINK
// Version sans erreurs pour assurer le fonctionnement de l'app

// Configuration Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBxO2_vQHm9L8nZfJ4kR3oP7sT6uWvYzAb",
  authDomain: "opticlink-7f972.firebaseapp.com",
  projectId: "opticlink-7f972",
  storageBucket: "opticlink-7f972.appspot.com",
  messagingSenderId: "123456789012",
  appId: "1:123456789012:web:abcdef123456789012345678",
  measurementId: "G-ABCDEFGHIJ"
};

// Fonctions stub pour éviter les erreurs
export const requestNotificationPermission = async () => {
  console.log('🔔 Firebase notifications (mode simulé)');
  return null;
};

export const setupNotificationListener = (callback) => {
  console.log('🔔 Setup notification listener (mode simulé)');
};

export const logOpticLinkEvent = (eventName, parameters = {}) => {
  console.log('📊 Analytics event (mode simulé):', eventName, parameters);
};

export const uploadOpticianDocument = async (file, opticienId, documentType) => {
  console.log('📁 Upload document (mode simulé):', file.name);
  return {
    success: false,
    error: 'Mode simulé - Firebase non activé'
  };
};

// Événements prédéfinis
export const OpticLinkEvents = {
  USER_REGISTRATION: 'user_registration',
  MISSION_CREATED: 'mission_created',
  APPLICATION_SENT: 'application_sent',
  CONTRACT_SIGNED: 'contract_signed',
  DOCUMENT_UPLOADED: 'document_uploaded',
  RETROCESSION_TRANSACTION: 'retrocession_transaction',
  LOGIN: 'login',
  PROFILE_COMPLETED: 'profile_completed'
};

console.log('📱 Firebase OPTIC LINK (mode simplifié) initialisé');
export default firebaseConfig;